import { useMutation } from '@apollo/client'
import { useState, useRef } from 'react'
import { Flex, Box, Heading, Button } from 'rebass/styled-components'
import { toast } from 'react-toastify';
import { ADD_APPOINTMENT_NOTE } from '../../../graphql/mutations';
import { IAddAppointmentNoteInput, IAddAppointmentNoteOutput } from '../../../graphql/types/mutations/appointment';
import { TextAreaNoForm } from '../../../components/TextArea';
import { GET_APPOINTMENT_NOTES } from '../../../graphql/queries';

interface ISendSmsProps {
  close: () => void
  appointmentId: string
}

export const AddAppointmentNote: React.FC<ISendSmsProps> = ({ appointmentId, close }) => {
  const [note, setNote] = useState<string>('');
  const [sendSms, { loading: loadingSendSms }] = useMutation<IAddAppointmentNoteOutput, IAddAppointmentNoteInput>(ADD_APPOINTMENT_NOTE, {
    awaitRefetchQueries: true,
    refetchQueries: [{
      query: GET_APPOINTMENT_NOTES,
      variables: {
        appointmentId: appointmentId
      }
    }]
  })


  const toastId = useRef<any>(null);
  const _send = async () => {

    toastId.current = toast("Adding appointment note", { autoClose: false, isLoading: true, closeButton: false });

    const res = await sendSms({
      variables: {
        appointmentId: appointmentId,
        note: note
      }
    })

    if (res && res.data && res.data.healthCoachAddAppointmentNote) {
      if (res.data.healthCoachAddAppointmentNote.ok) {
        toast.update(toastId.current, {
          render: 'Appointment note added!',
          type: toast.TYPE.SUCCESS,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
        close()
      } else {
        toast.update(toastId.current, {
          render: 'An error occured',
          type: toast.TYPE.ERROR,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      }
    } else {
      toast.update(toastId.current, {
        render: 'An error occured',
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 5000,
        closeButton: null // The closeButton defined on ToastContainer will be used
      });
    }
  }

  return (
    <Box style={{ margin: '0 auto', alignSelf: 'center', borderRadius: '20px', position: 'relative', backgroundColor: 'white', padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
      <Heading mb={4}>Add Appointment Note</Heading>
      <TextAreaNoForm
        autoFocus
        style={{ backgroundColor: 'white', flex: 1, minWidth: '430px', minHeight: '200px' }}
        placeholder='type your note here'
        onChange={(e: any) => setNote(e.target.value)}
        value={note}

      />
      <Flex flexDirection={'row'} justifyContent='space-between' width={'100%'}>
        <Button variant={'pink'} onClick={close} mt={4} disabled={!!loadingSendSms}>Cancel</Button>
        <Button variant={'primary'} onClick={_send} mt={4} disabled={!!loadingSendSms || !note || note.length < 2}>Send</Button>
      </Flex>
      <Box onClick={close} style={{ cursor: 'pointer', position: 'absolute', top: '-10px', right: '-10px', height: '34px', width: '34px', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#F8A294', padding: '6px', borderRadius: '50%', color: 'white' }}>
        X
      </Box>
    </Box>);
}